<template>
    <navbar id="headerNav" style="background: #ffffff">
        <ul class="nav navbar-nav d-md-down-none" :style="ulStyle" style="padding-left: 20px;;float: left;height: 65px;background: #438EB9;border-bottom: 0.1em solid #fffff0">
            <img :src="headlogo" style="width: 120px;height: 35px;" :style="headlogoStyle"/>
        </ul>
        <ul class="nav navbar-nav d-md-down-none" :style="ulStyle1" style="float: left;height: 65px;background: #438EB9;padding-left: 19px;border-bottom: 0.1em solid #fffff0">
            <span style="color: #fff;font-size: 16px;font-weight: bold">企业大数据平台</span>
        </ul>
        <ul class="nav navbar-nav ml-auto" style="width: 220px;">
            <Dropdown class="nav-item" style="padding-left: 40px;width: 180px;">
                <a href="javascript:void(0)">
           <span slot="button">
          <img src="/static/img/avatars/6.png" class="img-avatar" alt="o">
          <span class="d-md-down-none" style="color: #000;">{{username}}</span>
          </span>
                </a>
                <Dropdown-menu slot="list">
                    <!-- <Dropdown-item>
                       <p class="dropdown-itemp"><Icon type="alert"></Icon>Updates<span class="badge badge-info">42</span></p>
                     </Dropdown-item>
                     <Dropdown-item>
                       <p class="dropdown-itemp"><Icon type="chatbox-working"></Icon>Messages<span class="badge badge-success">42</span></p>

                     </Dropdown-item>
                      <Dropdown-item>
                       <p class="dropdown-itemp">  <Icon type="chatbox-working"></Icon>Messages<span class="badge badge-danger">42</span></p>

                    </Dropdown-item>
                       <Dropdown-item divided>
                       <p class="dropdown-itemp"><Icon type="android-contact"></Icon> Profile</p>

                       </Dropdown-item>
                     <Dropdown-item >
                       <p class="dropdown-itemp"><Icon type="android-settings"></Icon> Settings</p>
                       </Dropdown-item>-->
                    <Dropdown-item><a href="" @click="Logout">
                        <p class="dropdown-itemp">
                            <Icon type="power"></Icon>&nbsp;&nbsp;&nbsp;退出
                        </p>
                    </a></Dropdown-item>
                </Dropdown-menu>
            </Dropdown>
            <!-- <li class="nav-item d-md-down-none">
               <a class="nav-link navbar-toggler aside-menu-toggler"  @click="asideToggle">&#9776;</a>
             </li>-->
        </ul>
    </navbar>
</template>
<script>

    import navbar from './Navbar';
    import Cookies from 'js-cookie';

    export default {
        name: 'defaultHeader',
        data() {
            return {
                username: Cookies.get('SET_NAME'),
                navbarDisplay: "block",
                ulStyle:{
                    width:"145px"
                },
                ulStyle1:{
                    width:"145px"
                },
                headlogoStyle:{
                    width:"120px",
                    height:"35px"
                },
                headlogo:"/static/img/header/logob.png"
            }
        },
        components: {
            navbar,
        },
        created(){
            window.addEventListener('resize', this.handleResize);
            this.changeHeader();
        },
        methods: {
            handleResize(){
                this.changeHeader();
            },
            changeHeader(){
                const  width = document.body.clientWidth ||document.body.scrollWidth;
                const big = this.$store.getters.sidebarBigWidth;
                const small = this.$store.getters.sidebarSmallWidth;
                const critical = this.$store.getters.sidebarCriticalValue;
                if(width > critical){
                    this.ulStyle = {width:(big*0.5)+"px"};
                    this.ulStyle1 ={width:(big*0.5)+"px",display: ""};
                }else {
                    this.ulStyle = {width:small+"px"};
                    this.ulStyle1 ={display:"none"};
                }
                let systemName = this.$store.getters.systemName;
                if("/jzhk" == systemName){
                    this.headlogoStyle = {width:"120px",height:"35px"};
                    document.title = "企业大数据平台";
                    let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = "/static/img"+systemName+"/favicon.ico";
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                if("/sunway" == systemName){
                    this.headlogoStyle = {width:"120px",height:"30px"};
                    document.title = "企业大数据平台"
                }
                if("/fedu" == systemName){
                    this.headlogoStyle = {width:"170px",height:"25px"};
                    document.title = "就业企业速查平台"
                }
                if("/hyxy" == systemName){
                    this.headlogoStyle = {width:"170px",height:"25px"};
                    document.title = "数据资源平台"
                }
                if("/gooine" == systemName){
                    this.headlogoStyle = {width:"170px",height:"35px"};
                    document.title = "谷尼企业大数据"
                }
                if("/ckshi" == systemName){
                    this.headlogoStyle = {width:"170px",height:"35px"};
                    document.title = "企业大数据平台"
                }
                if("/bigdata" == systemName){
                    this.headlogoStyle = {width:"170px",height:"25px"};
                    document.title = "奥德塔学院"
                }
                this.headlogo = "/static/img/header"+systemName+"/logob.png";
            },
            Logout(e) {
                e.preventDefault();
                this.$store.dispatch('setFirstFlag', 0).then(() => {
                }).catch(err => {
                    this.$message.error(err);
                });
                this.$store.dispatch('LogOut').then(() => {
                    const url = this.$store.getters.url;
                    location.href = url+"/adt/enuser/index?wefvbh=1";
                }).catch(err => {
                    this.$message.error(err);
                });
            },
            click() {
                // do nothing
            },
            sidebarToggle(e) {
                e.preventDefault();
                document.body.classList.toggle('sidebar-hidden')
            },
            sidebarMinimize(e) {
                let array = [] = $("body").attr("class").split(" ");
                if (array.indexOf("sidebar-minimized") >= 0) {
                    this.navbarDisplay = "block";
                    $(".adt-span-special").each(function () {
                        $(this).css("position", "absolute");
                    });
                } else {
                    this.navbarDisplay = "none";
                    $(".adt-span-special").each(function () {
                        $(this).css("position", "");
                    });
                }
                document.getElementById("header-nav").classList.toggle('header-nav');
                document.body.classList.toggle('sidebar-minimized');
            },
            mobileSidebarToggle(e) {
                e.preventDefault()

                document.body.classList.toggle('sidebar-mobile-show')
            },
            asideToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('aside-menu-hidden')
            },
        }
    }
</script>

<style type="text/css" scoped>
    .header-nav {
        width: 50px;
        background-color: #2c3240 !important;
    }

    .dropdown-itemp {
        text-align: left;
        font-size: 15px;
        padding: 10px;
    }

    .header-item .ivu-dropdown-item {
        padding: 15px;
    }

    .header-item {
        width: 130px;
        /*background-color: #20a8d8;*/
        /*background-color: white;*/

        height: 55px;


    }

    .header-item a {
        color: white !important;

    }
    .ivu-icon-lingdang:before {
        content: url(../../static/img/ld.png);;
    }

</style>



// WEBPACK FOOTER //
// DefaultHeader.vue?590cd849